import { render, staticRenderFns } from "./PopsManageDocumentInfra.vue?vue&type=template&id=7d7483fc"
import script from "./PopsManageDocumentInfra.vue?vue&type=script&lang=js"
export * from "./PopsManageDocumentInfra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports